import React, { memo, MouseEventHandler } from "react";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { TRY_AGAIN } from "./constants";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import {
    QuickCheckoutErrorContainer,
    QuickCheckoutErrorContent,
    QuickCheckoutErrorHeader,
    QuickCheckoutErrorMessage,
    ButtonWrapper,
} from "./styles";

type QuickCheckoutErrorProps = {
    title: string;
    primaryActionText?: string;
    onClickPrimaryAction: MouseEventHandler<HTMLButtonElement>;
};

const QuickCheckoutError = ({
    title,
    primaryActionText,
    onClickPrimaryAction,
}: QuickCheckoutErrorProps): React.ReactElement => {
    return (
        <QuickCheckoutErrorContainer>
            <QuickCheckoutErrorContent>
                <QuickCheckoutErrorHeader>
                    <SpriteIconWeb iconName="errorFilled20" fillColor="negative" strokeColor="negative" />
                    <QuickCheckoutErrorMessage maxLines={2} variant="V2.body1.neutral.bold" color="text_High_Emphasis">
                        {title}
                    </QuickCheckoutErrorMessage>
                </QuickCheckoutErrorHeader>
                <ButtonWrapper>
                    <FullWidthButton variant="primary" onClick={onClickPrimaryAction}>
                        {primaryActionText || TRY_AGAIN}
                    </FullWidthButton>
                </ButtonWrapper>
            </QuickCheckoutErrorContent>
        </QuickCheckoutErrorContainer>
    );
};

export default memo(QuickCheckoutError);
